/**
 * data-reveal-link and data-reveal-next: navigate to slide by ref or next.
 */

export function setupRevealLinks(): void {
  function findSlideByRef(ref: string | null): Element | null {
    if (!ref || typeof document === 'undefined') return null;
    return document.getElementById(ref) || document.querySelector('section[data-id="' + ref + '"]');
  }

  function navigateToSlide(ref: string): boolean {
    const section = findSlideByRef(ref);
    if (!section || typeof Reveal === 'undefined') return false;
    try {
      window.location.hash = '#/' + ref;
      return true;
    } catch {
      return false;
    }
  }

  document.addEventListener('click', ((e: Event) => {
    const a = (e.target as Element)?.closest?.('a');
    if (!a) return;
    if (a.hasAttribute('data-reveal-next')) {
      e.preventDefault();
      if (typeof Reveal !== 'undefined' && typeof Reveal.next === 'function') {
        Reveal.next();
      }
      return;
    }
    let ref = a.getAttribute('data-reveal-link');
    if (!ref && a.hash && a.hash.length > 1 && a.hash.indexOf('#/') === 0) {
      ref = a.hash.slice(2).replace(/^\/+/, '').split('/')[0];
    }
    if (!ref) return;
    if (findSlideByRef(ref)) {
      e.preventDefault();
      navigateToSlide(ref);
    }
  }) as EventListener, true);
}
